import { render, staticRenderFns } from "./produceList.vue?vue&type=template&id=b7bcea3e&scoped=true&"
import script from "./produceList.vue?vue&type=script&lang=js&"
export * from "./produceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bcea3e",
  null
  
)

export default component.exports